import React from 'react';

//components
import ThriveModal from './ThriveModal';
import CancelConfirmPanel from '../buttons/buttonPanels/CancelConfirmPanel';

//styles
import "../../../styles/global/modals/cancel-confirm-modal.scss";


const  CancelConfirmModal = ({className, isAlertStyle, headerContent, bodyContent, onCloseClick, cancelButtonText, cancelButtonAriaLabel, confirmButtonText, confirmButtonAriaLabel, onCancelClick, onConfirmClick}:{className?: string, headerContent: any, isAlertStyle?: boolean, bodyContent: any, onCloseClick: ()=>void,  cancelButtonText: string, cancelButtonAriaLabel: string, confirmButtonText:string, confirmButtonAriaLabel: string, onCancelClick: ()=>void, onConfirmClick: ()=> void}) => {
    return (
        <ThriveModal 
            showModal
            className={`cancel-confirm-modal ${className}`}
            headerContent={headerContent} 
            bodyContent={bodyContent} 
            footerContent={<CancelConfirmPanel panelClassName={`cancel-confirm-modal-panel ${isAlertStyle ? "alert-style" : ""}`} cancelContent={cancelButtonText} confirmContent={confirmButtonText} ariaLabelCancel={cancelButtonAriaLabel} ariaLabelConfirm={confirmButtonAriaLabel} onCancelClick={onCancelClick} onConfirmClick={onConfirmClick} />} 
            onCloseClick={onCloseClick}
        />
    );
};

export default CancelConfirmModal;